import React from 'react';
import { Link } from '@morressier/alembic';
import { downloadFile, getFileExtension } from 'src/utils/file';
import { createFileViewerRequest } from 'src/utils/fileViewer';

function getSubmissionIdFromURL(url: string): string | undefined {
  try {
    const match = new URL(url).pathname.match(/\/submission\/([^/]+)/);
    return match?.[1];
  } catch {
    return undefined;
  }
}

function getOrganizationIdFromURL(url: string): string | undefined {
  try {
    const match = new URL(url).pathname.match(/\/organization\/([^/]+)/);
    return match?.[1];
  } catch {
    return undefined;
  }
}

const SUPPORTED_PREVIEW_EXTENSIONS = new Set(['pdf', 'doc', 'docx']);

interface PrivateAssetLinkProps {
  url: string;
  text: string;
}

const PrivateAssetLink: React.FC<PrivateAssetLinkProps> = ({ url, text }) => {
  const fileExtension = (getFileExtension(url) || '').toLowerCase();
  const organizationId = getOrganizationIdFromURL(url);
  const submissionId = getSubmissionIdFromURL(url);
  const canPreview = fileExtension && SUPPORTED_PREVIEW_EXTENSIONS.has(fileExtension);

  const handleClick = () => {
    if (!canPreview) {
      downloadFile(url, {
        submissionContextId: submissionId,
        organizationId
      });
      return;
    }

    const requestId = createFileViewerRequest({
      fileUrl: url,
      fileExtension,
      submissionContextId: submissionId,
      organizationId
    });

    window.open(
      `/file-viewer?requestId=${encodeURIComponent(requestId)}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <Link
      as="button"
      type="button"
      variant="secondary"
      onClick={handleClick}
    >
      {text}
    </Link>

);
};

export default PrivateAssetLink;
